import { ColorPickerField } from '../../components/ColorPickerField';
import { IconField } from '../../components/IconField';
import IconBlock from './IconBlock';

const iconBlockPluginController: any = {
  Renderer: ({ data }: any) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <IconBlock
        icon={data?.style?.icon}
        iconBackground={data?.style?.iconBackground}
        iconColor={data?.style?.iconColor}
        documentLink={data?.style?.documentLink}
      />
    </div>
  ),
  id: 'iconBlockPluginController',
  title: 'Icon Block',
  description: 'Customizable with icon selection',
  version: 1,
  controls: [
    {
      title: 'Styling',
      controls: {
        type: 'autoform',
        schema: {
          type: 'object',
          required: [],
          properties: {
            style: {
              type: 'object',
              required: [],
              properties: {
                icon: {
                  type: 'string',
                  default: 'Anchor 2',
                  uniforms: {
                    component: IconField,
                    label: 'Icon: ',
                  },
                },
                iconBackground: {
                  type: 'string',
                  default: 'rgba(255,255,255,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon Background Color: ',
                  },
                },
                iconColor: {
                  type: 'string',
                  default: 'rgba(0,0,0,1)',
                  uniforms: {
                    component: ColorPickerField,
                    label: 'Icon color: (*where applicable) ',
                  },
                },
                documentLink: {
                  type: 'string',
                  default: '',
                },
                padding: {
                  type: 'number',
                  default: 10,
                },
                width: {
                  type: 'number',
                  default: 200,
                },
              },
            },
          },
        },
      },
    },
  ],
};

export default iconBlockPluginController;
